import React from 'react';

interface CreditSummaryProps {
    currentBalance: number;
    summaryStats: {
        totalPurchased: number;
        totalUsed: number;
        totalOrders: number;
        totalGenerations: number;
        usageByType: {
            [key: string]: {
                count: number;
                total_credits: number;
            };
        };
    };
}

const CreditSummary: React.FC<CreditSummaryProps> = ({ currentBalance, summaryStats }) => {
    return (
        <div className="bg-secondary-600 rounded-xl p-6 text-white mb-6">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                {/* Current Balance */}
                <div className="text-center md:text-left">
                    <p className="text-secondary-100 text-sm font-medium">Current Balance</p>
                    <p className="text-3xl font-bold mt-1">
                        <i className="fas fa-coins mr-2"></i>
                        {currentBalance.toFixed(2)}
                    </p>
                </div>

                {/* Total Purchased */}
                <div className="text-center md:text-left">
                    <p className="text-secondary-100 text-sm font-medium">Total Purchased</p>
                    <p className="text-2xl font-semibold mt-1">
                        +{summaryStats.totalPurchased.toFixed(2)}
                    </p>
                    <p className="text-xs text-secondary-200">{summaryStats.totalOrders} orders</p>
                </div>

                {/* Total Used */}
                <div className="text-center md:text-left">
                    <p className="text-secondary-100 text-sm font-medium">Total Used</p>
                    <p className="text-2xl font-semibold mt-1">
                        -{summaryStats.totalUsed.toFixed(2)}
                    </p>
                    <p className="text-xs text-secondary-200">{summaryStats.totalGenerations} generations</p>
                </div>

                {/* Usage Rate */}
                <div className="text-center md:text-left">
                    <p className="text-secondary-100 text-sm font-medium">Usage Rate</p>
                    <p className="text-2xl font-semibold mt-1">
                        {summaryStats.totalPurchased > 0
                            ? Math.round((summaryStats.totalUsed / summaryStats.totalPurchased) * 100)
                            : 0}%
                    </p>
                    <p className="text-xs text-secondary-200">of purchased credits</p>
                </div>
            </div>
        </div>
    );
};

export default CreditSummary; 